import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'accent' | 'danger' | 'brand';
  className?: string;
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  const variants = {
    default: 'bg-neutral-100 text-neutral-700 border border-neutral-200',
    accent: 'bg-accent-500/15 text-accent-600 border border-accent-500/30 font-black',
    danger: 'bg-danger-500/15 text-danger-600 border border-danger-500/30',
    brand: 'bg-brand-500/15 text-brand-600 border border-brand-500/30 font-black',
  };
  
  return (
    <span className={cn('inline-flex items-center rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-wider', variants[variant], className)}>
      {children}
    </span>
  );
}

